import React from 'react';

const YandexReviewsWidget = () => {
    const widgetHtml = `
      <div style="width:100%;max-width:560px;height:650px;overflow:hidden;position:relative;margin:0 auto;box-sizing:border-box;">
        <iframe style="width:100%;height:100%;border:1px solid #e6e6e6;border-radius:12px;box-sizing:border-box;" 
          src="https://yandex.ru/maps-reviews-widget/165795693107?comments">
        </iframe>
        <a href="https://yandex.ru/maps/org/avtosteklo_servis/165795693107/" 
          target="_blank" 
          style="box-sizing:border-box;text-decoration:none;color:#b3b3b3;font-size:10px;font-family:sans-serif;padding:0 20px;position:absolute;bottom:8px;width:100%;text-align:center;left:0;overflow:hidden;text-overflow:ellipsis;display:block;max-height:14px;white-space:nowrap;">
          Автостекло-сервис на карте Бийска — Яндекс Карты
        </a>
      </div>
    `;

    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }} dangerouslySetInnerHTML={{ __html: widgetHtml }} />
    );
};

export default YandexReviewsWidget;